/* unplugin-vue-components disabled */import { render } from "./zhuhlist.vue?vue&type=template&id=d94a7348&scoped=true"
import script from "./zhuhlist.vue?vue&type=script&lang=js"
export * from "./zhuhlist.vue?vue&type=script&lang=js"

import "./zhuhlist.vue?vue&type=style&index=0&id=d94a7348&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94a7348"]])

export default __exports__